import { rei } from "@/services/api"

class ArquivosService {
  static removeArquivo (arquivoId) {
    return rei.delete(`arquivos/${arquivoId}`).then(res => res.data)
  }
}

export default ArquivosService
